import { useRouter } from 'next/router';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { useLoginFromHome } from '~/features/auth';
import LoginError from '~/features/error-message/LoginError';
import AuthLayout from '~/features/layouts/AuthLayout';
import { CanPlayAudioContext } from '~/shared/audio';
import Button from '~/shared/ui/button';
import FormActions from '~/shared/ui/form-actions';
import FormGroup from '~/shared/ui/form-group';
import Input from '~/shared/ui/input';
import { PanelTitle, PanelIntro } from '~/shared/ui/panel';

const Login = () => {
  const { hasShownModal } = useContext(CanPlayAudioContext);
  const { t } = useTranslation('auth');
  const router = useRouter();

  const { login, loading, error } = useLoginFromHome();

  async function handleSubmit(e) {
    e.preventDefault();

    login({
      redirectLoggedIn: async () =>
        router.replace(hasShownModal ? '/test/' : '/test/audio/'),
      username: e.currentTarget.username.value,
    });
  }

  return (
    <AuthLayout back="/" title={t('login.general.page_title')}>
      <PanelTitle>{t('login.home.title')}</PanelTitle>
      <PanelIntro>{t('login.home.intro')}</PanelIntro>
      <form onSubmit={handleSubmit}>
        <LoginError error={error} />
        <FormGroup
          label={t('login.general.fields.loginCode.label')}
          id="login-username"
        >
          <Input
            type="string"
            name="username"
            placeholder={t('login.general.fields.loginCode.placeholder')}
          />
        </FormGroup>
        <FormActions>
          <Button type="submit" iconAfter="arrow-right" disabled={loading}>
            {t('login.button_login')}
          </Button>
        </FormActions>
      </form>
    </AuthLayout>
  );
};

Login.options = {
  isPublic: true,
  isLogin: true,
};

export default Login;
